//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/NXObject.js";
import "../no/Routing.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"ApplicationType",1,0],[0,"CurrentDiscipline",1,0],[0,"CurrentSpecification",1,0],[0,"Description",0,0],[0,"Filename",0,0],[0,"Name",0,0]],[[["file_name"],"LoadAppView",{},1,0],[["num_names"],"GetDisciplines",{R_:{discipline_names:""}},0,0],[["num_specs"],"GetSpecifications",{R_:{spec_names:""}},0,0],[["nRequiredCharacteristics"],"GetRequiredCharacteristics",{R_:{requiredCharacteristics:""}},0,0],[["nOptionalCharacteristics"],"GetOptionalCharacteristics",{R_:{optionalCharacteristics:""}},0,0],[["nFabricationCharacteristics"],"GetFabricationCharacteristics",{R_:{fabricationCharacteristics:""}},0,0]],[["PartPreferences","Preferences.RoutingPart",0],["CharacteristicPreferences","Preferences.RoutingCharacteristics",0],["RoutingStock","Preferences.RoutingStock",0],["RoutingPath","Preferences.RoutingPath",0],["RoutingMechanical","Preferences.RoutingMechanical",0],["RoutingLogical","Preferences.RoutingLogical",0],["RoutingElectrical","Preferences.RoutingElectrical",0],["RoutingUserPreferences","Preferences.RoutingUserPreferences",0]]];
SPLM.Preferences.RoutingApplicationView = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingApplicationView";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingApplicationView.AppType = Object.freeze({
    "None" : "None", "Mechanical" : "Mechanical", "Electrical" : "Electrical", "Logical" : "Logical", "RsdMechanical" : "RsdMechanical", "RsdElectrical" : "RsdElectrical"});

export default SPLM;